import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/LogoPIM.png'


import { registerMgtLoginComponent } from "@microsoft/mgt-components";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

registerMgtLoginComponent()
// import { useUserStore } from "@/store/UserStore";
// import { onMounted } from "vue";
// import { useRouter } from "vue-router";

// const UserStore = useUserStore()
// const router = useRouter();
// onMounted(() => {
//   if (UserStore.signedIn) {
//     router.push({ name: "Dashboard" });
//   }
// });

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 24,
          style: {"margin-top":"20%","text-align":"center"}
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("img", {
              class: "logo",
              src: _imports_0,
              alt: "Idilia PIM logo"
            }, null, -1),
            _createElementVNode("div", { style: {"margin-left":"42%","width":"160px"} }, [
              _createElementVNode("div", { class: "login login-container" }, [
                _createElementVNode("mgt-login", { id: "mgtLogin" }, [
                  _createElementVNode("div", { "data-type": "signed-out" }, [
                    _createElementVNode("div", {
                      "data-type": "signed-out",
                      style: {"font-weight":"bold"}
                    }, " Sign In ")
                  ])
                ])
              ])
            ], -1)
          ])),
          _: 1,
          __: [0]
        })
      ]),
      _: 1
    })
  ]))
}
}

})